
/**
 * This class represent timer, that will do something after its over. It can also generate remaining time on page.
 */
 export default class Timer {

  /**
   * Constructor
   *
   * @param {Function} compareFunction
   * @param {number} compareDifference
   * @param {Function} callback what to do on timer end
   */
  constructor(compareFunction, compareDifference, callback) {
    this.pageLoadTime;
    this.endTime = undefined;
    this.timerElement;
    this.timer;

    this.compareFunction = compareFunction;
    this.compareDifference = compareDifference;
    this.callback = callback;
  }

  /**
   * This function starts the timer.
   */
  start() {
    this.pageLoadTime = new Date();

    if(this.timerElement !== undefined && this.endTime === undefined) {
      this.endTime = new Date(this.pageLoadTime.getTime());
      this.endTime.setMinutes(this.pageLoadTime.getMinutes() + this.compareDifference);
    }

    this.timer = setInterval(() => {
      let currentTime = new Date();

      // Compare current time with page load time using given compare functions (that shoudl be one of the static functions here)
      if(this.compareFunction(this.pageLoadTime, currentTime, this.compareDifference)) {
        this.callback();
      }

      if(this.timerElement !== undefined && this.timerElement.length > 0)
        this.updateTimerElement(currentTime);

    }, 1000);
  }

  /**
   * This function sets the timer element in which it will be shown.
   *
   * @param {string} selector
   */
  setTimerElement(selector) {
    this.timerElement = $(selector);

    // If the timer has set already remaining time set it as thhe end time using given compare difference.
    if(this.timerElement.length > 0 && this.timerElement.data('timer-remaining') !== '') {
        if(this.timerElement.data('timer') === "seconds") {
            let endDateMillis = Date.now() + this.compareDifference * 1000 - parseInt(this.timerElement.data('timer-remaining'));
            this.endTime = new Date(endDateMillis);
        } else {
            let endDateMillis = Date.now() + this.compareDifference * 60000 - parseInt(this.timerElement.data('timer-remaining'));
            this.endTime = new Date(endDateMillis);
        }
    }
  }

  /**
   * This function updates the timer element that is showing its progress.
   *
   * ! It only takes difference in minutes and it only show minutes and seconds.
   *
   * @param {Date} time current time
   */
  updateTimerElement(time) {
    let distance = this.endTime - time;

    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (distance < 0) {
      this.timerElement.addClass('timer--finished');
      clearInterval(this.timer);
      this.callback();
    } else {
        if (minutes === 0) {
            minutes = '00';
        } else if (minutes < 10) {
            minutes = '0'+minutes;
        }

        if(seconds === 0) {
            seconds = '00';
        } else if (seconds < 10) {
            seconds = '0'+seconds;
        }

        let stringTimer = '00:' + minutes + ':' + seconds;
        this.timerElement.html(stringTimer);
    }
  }

  /**
   * Comparator function for comparing days.
   *
   * @param {Date} loadTime starting time
   * @param {Date} currentTime progressing time
   * @param {number} compareDifference in number what should be the difference for refreshing the page
   *
   * @returns {boolean}
   */
   static compareDays(loadTime, currentTime, compareDifference) {
    return Math.abs(currentTime.getDate() - loadTime.getDate()) >= compareDifference;
  }

  /**
   * Comparator function for comparing minutes.
   *
   * @param {Date} loadTime starting time
   * @param {Date} currentTime progressing time
   * @param {number} compareDifference in number what should be the difference for refreshing the page
   *
   * @returns {boolean}
   */
  static compareMinutes(loadTime, currentTime , compareDifference) {
    let hoursDifference = currentTime.getHours() - loadTime.getHours();
    let multiplier = hoursDifference * 60;

    return (
      Math.abs(currentTime.getMinutes() + multiplier - loadTime.getMinutes()) >= compareDifference &&
      currentTime.getSeconds() == loadTime.getSeconds()
    );
  }

    /**
     * Comparator function for comparing seconds.
     *
     * @param {Date} loadTime starting time
     * @param {Date} currentTime progressing time
     * @param {number} compareDifference in number what should be the difference for refreshing the page
     *
     * @returns {boolean}
     */
    static compareSeconds(loadTime, currentTime , compareDifference) {
        let minutesDifference = currentTime.getMinutes() - loadTime.getMinutes();
        let multiplier = minutesDifference * 60;

        return (
            Math.abs(currentTime.getSeconds() + multiplier - loadTime.getSeconds()) >= compareDifference
        );
    }
}
